import { ReferencedOperationRelationship } from "../ars_ldm";
import { isExtensibleTerminologyTerm } from "./isExtensibleTerminologyTerm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a ReferencedOperationRelationship.
 *
 * @param obj - The value to check.
 * @returns True if the value is a ReferencedOperationRelationship.
 */
export const isReferencedOperationRelationship = (
  obj: unknown,
): obj is ReferencedOperationRelationship => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (typeof obj.operationId !== "string") return false;

  if (!isExtensibleTerminologyTerm(obj.referencedOperationRole)) return false;

  if (obj.analysisId !== undefined && typeof obj.analysisId !== "string") return false;
  if (obj.description !== undefined && typeof obj.description !== "string") return false;

  return true;
};
